import { EnrollmentInvestmentObjectiveCategory } from '@egw/api'
import { Button, Field, ModalDrawer, RadioGroup, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { sortInvestmentOptionGoals } from '../../../utils/investments/sort-investment-option-goals'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditInvestmentObjective: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()
  const [defaultInvestmentObjective, setDefaultInvestmentObjective] = useState<
    EnrollmentInvestmentObjectiveCategory | undefined
  >(undefined)

  const { control, watch, setValue } = useFormContext()

  const objectiveField = watch('objective')

  useEffect(() => {
    if (objectiveField !== undefined && defaultInvestmentObjective === undefined) {
      setDefaultInvestmentObjective(objectiveField)
    }
  }, [objectiveField])

  // Closes the modal and reverts the value to the default value
  // Only using the closeModal method will persist the value
  const closeWithoutSaving = () => {
    setValue('objective', defaultInvestmentObjective)
    closeModal()
  }

  // Sets the new default value for future edits
  const closeWithSaving = () => {
    setDefaultInvestmentObjective(objectiveField)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.investment_objective_title')}
        rightValue={t(`investment_objective_options.${objectiveField}`)}
        testId={'editInvestmentObjective'}
        onEdit={openModal}
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_investment_objective')}>
        <Controller
          name="objective"
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { ...restField } }) => (
            <RadioGroup
              {...restField}
              options={sortInvestmentOptionGoals(
                Object.values(EnrollmentInvestmentObjectiveCategory).map((item) => ({
                  value: item,
                  label: t(`multi.investment-goals.investment_objective.${item}`),
                })),
              )}
              name="objective"
              className="pb-md mt-md"
              testId="objective-radio"
            />
          )}
        />

        <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
          {t('common.confirm')}
        </Button>
      </ModalDrawer>
    </>
  )
}
